import { render } from "./ScanLocation.vue?vue&type=template&id=509a827c&scoped=true"
import script from "./ScanLocation.vue?vue&type=script&lang=js"
export * from "./ScanLocation.vue?vue&type=script&lang=js"

import "./ScanLocation.vue?vue&type=style&index=0&id=509a827c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-509a827c"]])

export default __exports__